import { useAuth } from '../context/AuthContext';

/**
 * Pure helper — usable outside React components (e.g. Layout.js nav filter).
 * Returns true when the admin has the given permission OR is a super_admin.
 */
export const can = (admin, permission) => {
  if (!admin) return false;
  if (admin.role === 'super_admin') return true;
  return Array.isArray(admin.permissions) && admin.permissions.includes(permission);
};

/**
 * Pure helper — returns true when the admin has ANY of the given permissions,
 * or is a super_admin. Use for routes/nav accessible by multiple roles.
 */
export const canAny = (admin, permissions) => {
  if (!admin) return false;
  if (admin.role === 'super_admin') return true;
  if (!Array.isArray(admin.permissions)) return false;
  return permissions.some((p) => admin.permissions.includes(p));
};

/**
 * React hook for permission checks.
 *
 * Usage:
 *   const { can, isSuperAdmin } = usePermissions();
 *   if (can('manage_rides')) { ... }
 */
const usePermissions = () => {
  const { admin } = useAuth();

  return {
    isSuperAdmin: admin?.role === 'super_admin',
    can: (permission) => can(admin, permission),
  };
};

export default usePermissions;
